import React from "react";
import {
  Datagrid,
  DateField,
  List,
  NumberInput,
  SimpleShowLayout,
  TextField,
  TextInput, required,

} from "react-admin";

import EditView from "../../../../components/EditView";
import CreateView from "../../../../components/CreateView";
import ShowView from "../../../../components/ShowView";
// import { makeStyles } from "@material-ui/core/styles";


// const useStyles = (width) => makeStyles({ image: { width } })();

export const ProductUnitList = (props) => {


  return (
    <List {...props} perPage={100} sort={{ field: 'order', order: 'ASC' }} >
      <Datagrid rowClick="show">
        <TextField source="order" />
        <TextField source="title" />
        <TextField source="symbol" />
      </Datagrid>
    </List>
  )
};

export const ProductUnitEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
    <NumberInput source="order" validate={required()} />
    <TextField source="symbol" />
  </EditView>
);

export const ProductUnitShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="order" />
      <TextField source="title" />
      <TextField source="symbol" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const ProductUnitCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()} />
    <NumberInput source="order" validate={required()} />
    <TextInput source="symbol" validate={required()} />
  </CreateView>
);
